import { idZodSchema } from "@@/shared/id";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { priceZodSchema } from "@@/shared/prices/price";
import { templateSpecificationZodObject } from "@@/shared/products/templates/shared/template-specification";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";

const templateDescriptionZodObject = z.object({
    // namngivning är svårt, vet inte om detta är så bra
    /** Beskrivning av vem mallen är till för. Text under rubrik: "Vem är detta för?" */
    targetDescription: z
        .object({
            // Vem är detta för?
            text: translatableZodSchema,
        })
        .optional(),
    // namngivning är svårt, vet inte om detta är så bra
    miniDescription: translatableZodSchema.optional(),
    specifications:
        // lista med spec-grupper; titel, description and items (icon + text)
        z.array(templateSpecificationZodObject).optional(),
    suggestedOptionals: z
        .array(
            z.object({
                _id: idZodSchema,
                meta: metaContentZodSchema,
                suggestedPriceRange: z
                    .object({
                        min: priceZodSchema,
                        max: priceZodSchema,
                    })
                    .optional(),
            }),
        )
        .optional(),
    suggestedPriceRange: z
        .object({
            min: priceZodSchema,
            max: priceZodSchema,
        })
        .optional(),
});

export { templateDescriptionZodObject };
